import { render, staticRenderFns } from "./HomeNews.vue?vue&type=template&id=73563357&scoped=true&"
import script from "./HomeNews.vue?vue&type=script&lang=ts&"
export * from "./HomeNews.vue?vue&type=script&lang=ts&"
import style0 from "./HomeNews.vue?vue&type=style&index=0&id=73563357&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73563357",
  null
  
)

export default component.exports